import { render } from "./risk-analysis.vue?vue&type=template&id=2c47ee19&scoped=true"
import script from "./risk-analysis.vue?vue&type=script&lang=js"
export * from "./risk-analysis.vue?vue&type=script&lang=js"

import "./risk-analysis.vue?vue&type=style&index=0&id=2c47ee19&scoped=true&lang=less"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c47ee19"]])

export default __exports__